<div class="row p-2" *ngIf="!hideHeaders">
  <div class="col-md-12 card card-body">
    <div class="row">
      <div class="col-6 col-sm-3 col-md-2 order-1">
      </div>
      <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
        <h4 class="h4-responsive">{{exercise?.title}}</h4>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">
        <input type="button" class="btn btn-secondary d-print-none" value="Print" (click)="print()" />
      </div>
    </div>
  </div>
</div>
<div [innerHTML]="ExerciseContent"></div>
<div class="card card-cascade wider mt-4 col-md-8 journalContainer" *ngIf="hasJournal()">
  <div class="view gradient-card-header secondary-gradient">
      <h4 class="h4-responsive"><i class="fa fa-pencil p-2"></i>Time for Reflection</h4>
  </div>
  <div class="card-body">
    <h5 class="text-center">{{exercise?.journal}}</h5>
    <div *ngIf="!result" #journal contenteditable="true" class="form-control journal"></div>
    <div *ngIf="result" #journal class="form-control journal"></div>
  </div>
</div>
<div class="row p-2 d-print-none"  *ngIf="!hideHeaders">
  <div class="col card card-body">
    <div class="row">
      <div class="col-6 col-sm-3 col-md-2 order-1">
      </div>
      <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
        <h4 class="h4-responsive">{{exercise?.title}}</h4>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">
        <input [disabled]="disabled" type="button" class="btn btn-primary" value="Submit" (click)="submit()" />
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/library-assets/exercise/exercise.component.html